import { Button } from "@mui/material";
import styled from "@emotion/styled";

const FastButton = styled(Button)`
  color: rgba(255, 255, 255, 1);
  border: none;
  box-shadow: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
`;

const FastButtonComponent = ({
  title,
  typeBtn = "btn",
  accept,
  ...rest
}: any) => {
  if (typeBtn === "file") {
    return (
      <FastButton {...rest}>
        <input
          type="file"
          accept={accept}
          style={{ position: "absolute", width: "100%", opacity: 0 }}
        />
        {title}
      </FastButton>
    );
  }

  return <FastButton {...rest}>{title}</FastButton>;
};

export default FastButtonComponent;
